import React from 'react';
import PropTypes from 'prop-types';
import ChevronLeftIcon from 'material-design-icons/navigation/svg/production/ic_chevron_left_24px.svg';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import c from './BackButton.less';

export default function BackButton({
  to, title, onClick, className, desktopHidden,
}) {
  if (typeof onClick === 'function') {
    return (
      <button
        type="button"
        onClick={onClick}
        className={cx({ 'hidden-desktop': desktopHidden }, c.backButton, className)}
      >
        <ChevronLeftIcon className={c.backIcon} />
        {title}
      </button>
    );
  }

  return (
    <Link to={to} className={cx({ 'hidden-desktop': desktopHidden }, c.backButton)}>
      <ChevronLeftIcon className={c.backIcon} />
      {title}
    </Link>
  );
}

BackButton.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  to: (props, propName, componentName) => { // eslint-disable-line
    if (!props.to && !props.onClick) {
      return new Error(`One of props 'to' or 'onClick' was not specified in '${componentName}'.`);
    }
  },

  onClick: (props, propName, componentName) => { // eslint-disable-line
    if (!props.to && !props.onClick) {
      return new Error(`One of props 'to' or 'onClick' was not specified in '${componentName}'.`);
    }
  },
  desktopHidden: PropTypes.bool,
};

BackButton.defaultProps = {
  title: 'Back',
  className: null,
  to: null,
  onClick: null,
  desktopHidden: true,
};
